import { FC } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { Icon } from 'src/components';
import { ReviewTime, ReviewTimeUnit } from '../getReviewTime';
import * as S from './styles';

const msgs = defineMessages({
  minutes: {
    id: 'blob_eos_review_in_minutes',
    defaultMessage: 'Review in {count, plural, one {# minute} other {# minutes}}',
  },
  hours: {
    id: 'blob_eos_review_in_hours',
    defaultMessage: 'Review in {count, plural, one {# hour} other {# hours}}',
  },
  days: {
    id: 'blob_eos_review_in_days',
    defaultMessage: 'Review in {count, plural, one {# day} other {# days}}',
  },
  weeks: {
    id: 'blob_eos_review_in_weeks',
    defaultMessage: 'Review in {count, plural, one {# week} other {# weeks}}',
  },
  months: {
    id: 'blob_eos_review_in_months',
    defaultMessage: 'Review in {count, plural, one {# month} other {# months}}',
  },
});

const shortMsgs = defineMessages({
  minutes: {
    id: 'blob_eos_review_in_minutes_short',
    defaultMessage: 'In {count, plural, one {# minute} other {# minutes}}',
  },
  hours: {
    id: 'blob_eos_review_in_hours_short',
    defaultMessage: 'In {count, plural, one {# hour} other {# hours}}',
  },
  days: {
    id: 'blob_eos_review_in_days_short',
    defaultMessage: 'In {count, plural, one {# day} other {# days}}',
  },
  weeks: {
    id: 'blob_eos_review_in_weeks_short',
    defaultMessage: 'In {count, plural, one {# week} other {# weeks}}',
  },
  months: {
    id: 'blob_eos_review_in_months_short',
    defaultMessage: 'In {count, plural, one {# month} other {# months}}',
  },
} satisfies Record<ReviewTimeUnit, unknown>);

type ReviewPillProps = ReviewTime & {
  /** Drops the "Review" prefix where space is tight */
  short?: boolean;
};

export const ReviewPill: FC<ReviewPillProps> = ({ unit, count, short = false }) => {
  const intl = useIntl();

  return (
    <S.Pill data-testid="blob-eos-review-pill">
      <Icon name="timer" />
      {intl.formatMessage(short ? shortMsgs[unit] : msgs[unit], { count })}
    </S.Pill>
  );
};
